import SearchFormSidebar from './component'

export default SearchFormSidebar